export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/referral_program_perseus/header_guest.477e31f.png";